import { useCallback, useEffect, useState } from 'react';

export const useFullscreen = (element = null) => {
    const [ isFullscreen, setFullscreen ] = useState<boolean>(false);

    useEffect(() => {
        document.addEventListener('fullscreenchange', onFullscreenChange, false);

        return () => {
            document.removeEventListener(
                'fullscreenchange',
                onFullscreenChange,
                false,
            );
        };
    }, []);

    const onFullscreenChange = useCallback(() => {
        setFullscreen(Boolean(document.fullscreenElement));
    }, []);

    const toggleFullscreen = useCallback(() => {
        if (!document.fullscreenEnabled || !Boolean(element)) { return; }
        if (!document.fullscreenElement) {
            if (element?.requestFullscreen) {
                element.requestFullscreen();
            }
        } else {
            if (document?.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    }, [element])

    return {
        isFullscreen,
        toggleFullscreen
    }
}
